import { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import styled from "styled-components";
import { Button, SpinLoading, Dialog } from "antd-mobile";
import useNavigation from "../../hooks/useNavigation";
import PageWrap from "../components/PageWrap";
import PageHeader, { headerHeight } from "../components/PageHeader";
import { useStores } from "../../models";
import { ToastError, ToastSuccess } from "../../components/Toast";
import { formatPrice } from "../../utils";

const ScrollArea = styled.div`
  height: calc(100% - ${headerHeight});
  overflow: auto;
  background: #f7f8ff;
`;
const Content = styled.div`
  padding: 12px;
`;

const PeddingOrderDetail = () => {
  const { params, navigate } = useNavigation();
  const { orderStore } = useStores();
  const [detail, setDetail] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    (async () => {
      try {
        const res = await orderStore.loadMyOrderDetail(params.id);
        setDetail(res?.data || res);
      } catch (e: any) {
        ToastError(e.message);
      } finally {
        setLoading(false);
      }
    })();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);

  const cancel = () => {
    Dialog.confirm({
      content: "确认取消挂单？",
      onConfirm: () => {
        orderStore.publicPendingOrderCancel(
          { order_no: params.id } as any,
          () => { ToastSuccess("已取消"); navigate("MyOrderList"); },
          (e: any) => ToastError(e.message)
        );
      },
    });
  };

  return (
    <PageWrap>
      <PageHeader title="挂单详情" />
      <ScrollArea>
        <Content>
          {loading ? <SpinLoading /> : (
            <>
              <div style={{ background: "#fff", padding: 12, borderRadius: 8 }}>
                <div>单号: {detail?.order_no || params.id}</div>
                <div>数量: {detail?.quantities ?? "-"}</div>
                <div>单价: {formatPrice(detail?.amount || 0)}</div>
                <div>库存: {detail?.stock ?? "-"}</div>
              </div>
              <Button style={{ marginTop: 12 }} block onClick={() => navigate("PeddingOrderLog", { id: params.id })}>查看成交记录</Button>
              <Button color="danger" style={{ marginTop: 12 }} block onClick={cancel}>取消挂单</Button>
            </>
          )}
        </Content>
      </ScrollArea>
    </PageWrap>
  );
};
export default observer(PeddingOrderDetail);

